import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-asesoramiento-pedagogico',
  templateUrl: './subpage-asesoramiento-pedagogico.component.html',
  styleUrls: ['./subpage-asesoramiento-pedagogico.component.scss']
})
export class SubpageAsesoramientoPedagogicoComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
